import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

import {API_REQUEST_STEP_SUBMIT} from '../../../../../config/urls';
import {UrlService} from '@shared/services/url.service';
import {RequestStepUpdateDto} from '@dto/requests/request-step-update.dto';

@Injectable({
  providedIn: 'root'
})
export class AdaptiveCardRequestService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public save(requestId: string, requestStepId: number, adaptiveCardData: Record<string, string>): Observable<RequestStepUpdateDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP_SUBMIT, requestId, String(requestStepId));
    return this.http.post<RequestStepUpdateDto>(endpointUrl, adaptiveCardData);
  }
}
